var map = {
	"./site-logo-desktop-footer.svg": 32344,
	"./site-logo-desktop.svg": 37532,
	"./site-logo-drawer-mobile.svg": 14466,
	"./site-logo-drawer.svg": 12515,
	"./site-logo-mobile.svg": 68754,
	"./site-logo-sm.svg": 57008,
	"./site-logo-tv.svg": 6118,
	"./site-logo-wrapper-mobile-scrolled.svg": 24141,
	"./site-logo-wrapper-mobile.svg": 74600,
	"./site-logo-wrapper-scrolled.svg": 93890,
	"./site-logo-wrapper.svg": 94925
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 19992;